import { ITownsState } from '../states';

export const initialTownsState: ITownsState = {
  values: [],
  isFetchingTowns: false,
};
